import { render } from "./SurveyBuilderGenerator.vue?vue&type=template&id=76b3f035"
import script from "./SurveyBuilderGenerator.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderGenerator.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__